import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { ModalButton, ApiDownloadButton, CopyButton } from 'components/common';
import { FormGroup, TextArea } from 'components/common/form';

import type { Course } from 'shared-types';

interface Props {
  buttonIsDropdown?: boolean;
  buttonTooltip?: string;
  targetLanguage: Course['language'];
}

const SettingsExportLanguageVersions = ({
  buttonIsDropdown = false,
  buttonTooltip,
  targetLanguage
}: Props) => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const { data, loading } = useApiData<Record<string, string>>({
    url: `/admin/courses/${course.id}/language-versions-data-export/${targetLanguage}`
  });

  let jsonString = '';
  if (data) {
    try {
      jsonString = JSON.stringify(data, null, 2);
    } catch {
      jsonString = '';
    }
  }

  return (
    <ModalButton
      buttonIsDropdown={buttonIsDropdown}
      icon={'file-export'}
      loading={loading}
      modalProps={{
        closeButton: true,
        title: messages.manageExportJson,
        width: 'wide'
      }}
      size="small"
      text={messages.manageExportJson}
      tooltip={buttonTooltip}
    >
      <>
        <FormGroup label={messages.courseLanguageVersionData} maxWidth="100%">
          <TextArea
            disabled={true}
            field="language-versions-data"
            id="language-versions-data"
            initialValue={jsonString}
            rows={20}
            style={{ marginTop: 5 }}
          />
        </FormGroup>

        <div
          style={{
            display: 'flex',
            gap: 10,
            justifyContent: 'flex-end',
            marginTop: 16
          }}
        >
          <ApiDownloadButton
            category="default"
            icon="download"
            filename={`${course.slug}-${targetLanguage}.json`}
            text={messages.commonDownloadFile}
            url={`/admin/courses/${course.id}/language-versions-data-export/${targetLanguage}`}
          />

          <CopyButton
            successText={messages.commonCopied}
            text={messages.settingsExportCourseCopyData}
            value={jsonString}
          />
        </div>
      </>
    </ModalButton>
  );
};

export default SettingsExportLanguageVersions;
